var map = {
	"./bg.js": [
		6559,
		[
			49
		]
	],
	"./de.js": [
		5627,
		[]
	],
	"./en.js": [
		5879,
		[
			661
		]
	],
	"./es.js": [
		5188,
		[
			506
		]
	],
	"./fr.js": [
		7616,
		[
			738
		]
	],
	"./it.js": [
		3125,
		[
			723
		]
	],
	"./sl.js": [
		1719,
		[
			465
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5860;
module.exports = webpackAsyncContext;